import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { colors } from '../../../styles/colors'
import { getFormatedData } from '../../../functions/getFormatedData'
import { useFirebaseConnect } from 'react-redux-firebase'
import { SideCard } from './SideCard'
import { Arrow } from './Arrow'
import { MainCard } from './MainCard'
import { Loading } from '../../UI/Loading'

const Container = styled.div`
    @media (max-width: 320px) {
    }

    // INCLUDED CLASSES:

    .cards {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        
        @media (min-width: 768px) {
            position: relative;
        }
    }

    // 

    .slider-navigation-buttons {
        display: flex;
        justify-content: center;
        align-items: center;    

        margin: 9rem auto 0 auto;

        @media (max-width: 320px) {
            margin: 5rem auto 0 auto;
        }
    }
    .prev,
    .next {
        cursor: pointer;
        transition: all .5s;
        :hover {
            svg path {
                fill: ${colors.red};
            }
        }
    }
    .next {
        transform: rotate(180deg);
        margin-left: 12.5rem;
        margin-bottom: 8px;
    }

    .preloader {
        display: flex;
        justify-content: center;
    }
`

export const PartnersSlider = () => {
    
    useFirebaseConnect(['partners'])

    const partners = getFormatedData(useSelector(state => state.firebase.data.partners))
    const [startPoint, setStartPoint] = useState(0)

    function handleClick (dir) {
        if ( dir === 'prev' ) {
            if ( startPoint > 0 ){
                setStartPoint( startPoint - 1 )
            } else {
                setStartPoint( partners.length - 1 )
            }
        } else {
            if ( startPoint === partners.length - 1 ){
                setStartPoint( 0 )
            } else {
                setStartPoint( startPoint + 1 )
            }
        }
    }

    return (
        <Container>
            { partners && partners.length !== 0 ? (
                <>
                    <div className="cards">
                        <SideCard data={ partners[getDataForFirstCard(startPoint)] } />
                        <MainCard data={ partners[getDataForMaintCard(startPoint, partners)] } />
                        <SideCard data={ partners[getDataForLasttCard(startPoint, partners)] } />
                    </div>
                    <div className="slider-navigation-buttons">
                        <div className="prev" onClick={ ()=> handleClick('prev') }><Arrow /></div>
                        <div className="next" onClick={ ()=> handleClick('next') }><Arrow /></div>
                    </div>
                </>
            ) : <Loading /> }
        </Container>
    )
}

function getDataForFirstCard (start_elem) {
    return start_elem
}
function getDataForMaintCard (start_elem, arr) {
    let num;
    if (start_elem === arr.length - 1) {
        num = 0
    } else {
        num = start_elem + 1 
    }
    return num
}
function getDataForLasttCard (start_elem, arr) {
    let num;

    if (start_elem === arr.length - 1) {
        num = 1
    } else if (start_elem === arr.length - 2) {
        num = 0 
    } else {
        num = start_elem + 2 
    }

    return num
}
